<script setup>
import { Link, router, usePage } from '@inertiajs/vue3';
import { Icons } from '@goodvibes/kudoslink';
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue';
import { UserIcon } from '@heroicons/vue/24/solid';
import { ChevronDownIcon } from '@heroicons/vue/24/outline';
import AvatarTextual from './AvatarTextual.vue';

const page = usePage();

defineProps({
  placement: { type: String, default: 'bottom' }
});

function logout() {
    localStorage.clear();
    sessionStorage.clear();

    router.post(route('logout'));
}
</script>

<template>
    <Menu as="div" class="inline-block text-left relative" v-slot="{ open }">
        <MenuButton class="flex items-center justify-center w-full gap-x-2">
            <img v-if="page.props.auth.user?.avatar" :src="page.props.auth.user.avatar" class="shrink-0 grow-0 w-10 aspect-square rounded-full object-cover" />
            <AvatarTextual v-else :name="page.props.auth.user?.name"/>
            <span class="font-semibold text-sm text-gray-700">{{ page.props.auth.user.name }}</span>
            <ChevronDownIcon 
              class="ml-4 h-4 stroke-gray-500 stroke-2 transition-transform duration-200"
              :class="{'rotate-180': placement === 'top' && open }"
            />
        </MenuButton>

      <transition
        enter-active-class="transition duration-100 ease-out"
        enter-from-class="transform scale-95 opacity-0"
        enter-to-class="transform scale-100 opacity-100"
        leave-active-class="transition duration-75 ease-in"
        leave-from-class="transform scale-100 opacity-100"
        leave-to-class="transform scale-95 opacity-0"
      >
        <MenuItems
          class="absolute left-0 right-0 origin-top-right divide-y divide-gray-100 rounded-xl bg-white shadow-md ring-1 ring-black/5 focus:outline-none z-10"
          :class="{'bottom-full -translate-y-4': placement === 'top', 'top-full translate-y-4': placement === 'bottom'}"
          >
          <div class="px-1 py-1">
            <MenuItem v-slot="{ active }">
              <button
                :class="[
                  active ? '' : '',
                  'group flex justify-between w-full items-center rounded-lg px-2 py-2 text-sm',
                ]"
                @click="logout"
              >
                Sign out
                <Icons.ExitIcon
                  :active="active"
                  class="mr-2 h-4 w-4"
                  aria-hidden="true"
                />
              </button>
            </MenuItem>
          </div>
        </MenuItems>
      </transition>
    </Menu>
</template>
